import React, { PureComponent } from 'react';

import { ContentWrap } from './styles';

export default class CheckoutContentWrap extends PureComponent {
    render() {
        const { children } = this.props;
        return <ContentWrap>{children}</ContentWrap>;
    }
}
